import { GMFormTextField } from '../../TextField';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { GMFormEmailFieldProps } from '..';
import { NO_INVALID_EMAIL_CHARS_REGEX } from '../../../../CommonUtils/Validation';

/**
 * GMFormEmailField that uses GMFormTextField and blocks spaces and parentheses as-typed.
 */
const FormEmailField: GoMotoComponent<GMFormEmailFieldProps> = ({
    ...props
}) => {
    return (
        <GMFormTextField
            {...props}
            onChangeRegexTest={NO_INVALID_EMAIL_CHARS_REGEX}
        />
    );
};

export default FormEmailField;
